import { createIcon } from '@chakra-ui/react';

export const SubscriptionErrorIcon = createIcon({
  displayName: 'SubscriptionErrorIcon',
  viewBox: '0 0 16 16',
  defaultProps: {
    fill: 'none',
    height: '4',
    width: '4',
  },
  path: (
    <path
      d="M8.00024 1.33301C11.682 1.33319 14.6672 4.31822 14.6672 8C14.6671 11.6816 11.6819 14.6668 8.00024 14.667C4.31846 14.667 1.33343 11.6817 1.33325 8C1.33325 4.31811 4.31835 1.33301 8.00024 1.33301ZM7.33325 12.0029H8.66724V10.666H7.33325V12.0029ZM7.33325 9.33398H8.66724V4H7.33325V9.33398Z"
      fill="#EF4E4E"
    />
  ),
});
